<!-- <IFA-header></IFA-header> -->
<div class="Optimum-official-offerings" id="Optimum-wealth-home">
  <div class="insurance-wrapper pt-70 mobilept-22 nps-wrapper">
    <section class="section-insur" id="about-insurance">
      <div class="container">
        <div class="insur-row">
          <div class="insur-left-block">
            <div
              class="content-panel"
              style="background-color: #f5f5f5 !important">
              <div class="row d-flex">
                <div class="col-12">
                  <div class="sb-tag sb-offerings mb-12">About Us</div>
                  <h2 class="wealth-section-title mb-6">About Us</h2>
                  <p class="wealth-section-description mobilemb-5">
                    Know more of who we are and how we do it.
                  </p>
                </div>
              </div>
              <p class="mt-20 mobilemt-0" [innerHtml]="aboutusparagraph"></p>
              <div class="cta-block" (click)="modalPopOpen()">
                <a class="primary-cta" style="color: #fff !important">
                  Let's Talk
                </a>
              </div>
            </div>
          </div>
          <div class="insur-right-block desktopHide">
            <img
              src="../../assets/images/img/Aboutus.jpg"
              data-target="#wealth-video-testimonial"
              data-toggle="modal" />
          </div>
        </div>
      </div>
    </section>
  </div>
</div>

<IFA-footer></IFA-footer>
